import { jsx, jsxs } from "react/jsx-runtime";
import { Toast, useToastController, useToastState } from "@tamagui/toast";
import React from "react";
import { Button, Label, Switch, XStack, YStack } from "tamagui";
const ToastDemo = () => {
  const [native, setNative] = React.useState(false);
  return /* @__PURE__ */ jsxs(YStack, { space: true, alignItems: "center", children: [
    /* @__PURE__ */ jsx(ToastControl, { native }),
    /* @__PURE__ */ jsx(CurrentToast, {}),
    /* @__PURE__ */ jsx(NativeOptions, { native, setNative })
  ] });
};
const CurrentToast = () => {
  const currentToast = useToastState();
  if (!currentToast || currentToast.isHandledNatively)
    return null;
  return /* @__PURE__ */ jsx(
    Toast,
    {
      duration: currentToast.duration,
      enterStyle: { opacity: 0, scale: 0.5, y: -25 },
      exitStyle: { opacity: 0, scale: 1, y: -20 },
      y: 0,
      opacity: 1,
      scale: 1,
      animation: "100ms",
      viewportName: currentToast.viewportName,
      children: /* @__PURE__ */ jsxs(YStack, { children: [
        /* @__PURE__ */ jsx(Toast.Title, { children: currentToast.title }),
        !!currentToast.message && /* @__PURE__ */ jsx(Toast.Description, { children: currentToast.message })
      ] })
    },
    currentToast.id
  );
};
const ToastControl = ({ native }) => {
  const toast = useToastController();
  return /* @__PURE__ */ jsxs(XStack, { space: "$2", justifyContent: "center", children: [
    /* @__PURE__ */ jsx(
      Button,
      {
        onPress: () => {
          toast.show("Successfully saved!", {
            message: "Don't worry, we've got your data.",
            native
          });
        },
        children: "Show"
      }
    ),
    /* @__PURE__ */ jsx(
      Button,
      {
        id: "wot",
        nativeID: "woot",
        onPress: () => {
          toast.hide();
        },
        children: "Hide"
      }
    )
  ] });
};
const NativeOptions = ({
  native,
  setNative
}) => {
  return /* @__PURE__ */ jsxs(XStack, { space: "$3", children: [
    /* @__PURE__ */ jsx(Label, { size: "$1", onPress: () => setNative(false), children: "Custom" }),
    /* @__PURE__ */ jsx(
      Switch,
      {
        debug: "verbose",
        id: "native-toggle",
        nativeID: "native-toggle",
        theme: "active",
        size: "$1",
        checked: !!native,
        onCheckedChange: (val) => setNative(val),
        children: /* @__PURE__ */ jsx(
          Switch.Thumb,
          {
            animation: [
              "quick",
              {
                transform: {
                  overshootClamping: true
                }
              }
            ]
          }
        )
      }
    ),
    /* @__PURE__ */ jsx(Label, { size: "$1", onPress: () => setNative(true), children: "Native" })
  ] });
};
export {
  ToastDemo
};
//# sourceMappingURL=ToastDemo.js.map
